import { Select, MenuItem } from "@mui/material";
import { GridFilterInputValueProps } from "@mui/x-data-grid";
import { SelectChangeEvent } from "@mui/material/Select";


export function FilterRoleInput(props: GridFilterInputValueProps) {
  const { item, applyValue } = props;
  const roles = ["Admin", "User"];
  const handleChange = (event: SelectChangeEvent) => {
    applyValue({ ...item, value: event.target.value });
  };

  return (
    <Select
      value={item.value || ""}
      onChange={handleChange}
      displayEmpty
      fullWidth
    >
      <MenuItem value="">All</MenuItem>
      {roles.map((roles) => (
        <MenuItem key={roles} value={roles}>
          {roles}
        </MenuItem>
      ))}
    </Select>
  );
}